import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getPAGAA000, getPAGAA020 } from '../../../services/Api';
import Carousel from '../../../shared/components/Carousel';
import Nav from '../../../shared/components/Nav';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { formatDate, shouldDisplayMenu, updateMenuVisibility } from '../../../utils';
const PAGAA020 = () => {
    const { id } = useParams({});
    const [data, setData] = useState({});
    const [bizImage, setBizImage] = useState([]);
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);
    const [menuData, setMenuData] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
                setMenuData(data);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        getPAGAA020(id)
            .then(({ data }) => {
                setData(data);
                setBizImage((data?.bizImages ?? '').split(','));
            })
            .catch((error) => console.log(error));
    }, [id]);

    return (
        <div id="content">
            <div id="tab-follow">
                <div className="container">
                    <Nav menu={dentalPlusMenu} />
                </div>
            </div>
            <div id="vln" className="vln">
                <div className="container">
                    <div className="vln-top">
                        {/* <div id="volunteer-slide" className="carousel slide vln-top__img" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {bizImage !== null ? (
                                    <Carousel
                                        dataSlide={(bizImage ? bizImage : []).filter(Boolean)}
                                        dataName="BizImage"
                                    />
                                ) : (
                                    <Carousel
                                        dataSlide={['./images/default_logo.jpg']}
                                        dataName="BizImage"
                                        dataSlideDefault={true}
                                    />
                                )}
                            </div>
                        </div> */}
                        {bizImage[0] !== '' ? (
                            <div className="carousel-inner vln-top__img vln-top__imgStyle" style={{ width: '200px' }}>
                                <Carousel dataSlide={(bizImage ? bizImage : []).filter(Boolean)} dataName="BizImage" />
                            </div>
                        ) : (
                            <span>{data?.agency}</span>
                        )}
                        <div className="vln-top__info">
                            <h2>{data?.title}</h2>
                        </div>
                        <a className="vln-top__link" href={data?.dentalPage} target="_blank" rel="noreferrer">
                            <img src="./images/icons/icon-homepage.png" alt="icon-home" />
                        </a>
                    </div>
                    <h3 className="rsm__sub">모집요강</h3>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>모집직종</th>
                                <td>{data?.certificate}</td>
                            </tr>
                            <tr>
                                <th>모집인원</th>
                                <td>{data?.numberOfPositions}</td>
                            </tr>
                            <tr>
                                <th>자격요건</th>
                                <td>{data?.license}</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 className="rsm__sub">봉사내용</h3>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>봉사기간</th>
                                <td>{data?.period}</td>
                            </tr>
                            <tr>
                                <th>봉사지역</th>
                                <td>{data?.jobLocation}</td>
                            </tr>
                            <tr>
                                <th>봉사활동</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: data?.contents ? decodeHTML(data?.contents) : '',
                                    }}
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 className="rsm__sub">모집기간 및 제출사항</h3>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>모집기간</th>
                                <td className="blue">
                                    {data?.isIndefinite === 'Y'
                                        ? '상시모집'
                                        : formatDate(data?.startDate) + ' ~ ' + formatDate(data?.endDate)}
                                </td>
                            </tr>
                            <tr>
                                <th>지원방법</th>
                                <td>
                                    <div style={{ whiteSpace: 'pre-line' }}>{data?.applyMethod}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 className="rsm__sub">담당자 정보</h3>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>담당자명</th>
                                <td>{data?.contactPerson}</td>
                            </tr>
                            <tr>
                                <th>담당자 연락처</th>
                                <td>{data?.contactNumber}</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 className="rsm__sub">모집기관 정보</h3>
                    <table className="job-table">
                        <tbody>
                            <tr>
                                <th>모집기관</th>
                                <td>{data?.agency}</td>
                            </tr>
                            <tr>
                                <th>대표자명</th>
                                <td>{data?.dentalOwner}</td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>{data?.location}</td>
                            </tr>
                            <tr>
                                <th>모집기관 소개</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: data?.dentalInfo ? decodeHTML(data?.dentalInfo) : '',
                                    }}
                                ></td>
                            </tr>
                            <tr>
                                <th>기타 세부사항</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: data?.infoOther ? decodeHTML(data?.infoOther) : '',
                                    }}
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                    {shouldDisplayMenu('pagaa010', menuData) && (
                        <div className="vln-btnbx">
                            <Link to="/pagaa010" className="vln-listbtn">
                                목록
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PAGAA020;
